import CookieService from './CookieService'

class MixpanelCookieService extends CookieService {
    DEVICE_ID = 'mp_device_id'
    USER_TYPE = 'mp_user_type'
    UNICITY_ID = 'mp_unicity_id'
    IS_USER_LOGGED_IN = 'mp_is_user_logged_in'
    LANGUAGE = 'mp_language'
    COUNTRY = 'mp_country'
    INITIAL_REFERRER = 'mp_initial_referrer'
    INITIAL_REFERRING_DOMAIN = 'mp_initial_referring_domain'
    USER_INITIALIZED_IN_MIXPANEL = 'mp_userInitializedInMixpanel'
    IS_INITIAL_WITH_MANY_REDIRECTS = 'mp_is_initial_with_many_redirects'

    setUserType(userType) {
        this.set(this.USER_TYPE, userType)
    }

    setIsUserLoggedIn(isUserLoggedIn) {
        this.set(this.IS_USER_LOGGED_IN, isUserLoggedIn)
    }

    setDeviceId(deviceId) {
        this.set(this.DEVICE_ID, deviceId)
    }

    setUnicityId(unicityId) {
        this.set(this.UNICITY_ID, unicityId)
    }

    setLanguage(language) {
        const languageLowerCase = language.toLowerCase()
        this.set(this.LANGUAGE, languageLowerCase)
    }

    setCountry(country) {
        this.set(this.COUNTRY, country)
    }

    setInitialReferrer(initialReferrer) {
        this.set(this.INITIAL_REFERRER, initialReferrer)
    }

    setInitialReferringDomain(initialReferringDomain) {
        this.set(this.INITIAL_REFERRING_DOMAIN, initialReferringDomain)
    }

    setUserInitializedInMixpanel(userInitializedInMixpanel) {
        this.set(this.USER_INITIALIZED_IN_MIXPANEL, userInitializedInMixpanel)
    }

    setIsInitialWithManyRedirects(isInitialWithManyRedirects) {
        this.set(this.IS_INITIAL_WITH_MANY_REDIRECTS, isInitialWithManyRedirects)
    }

    getUserType() {
        return this.get(this.USER_TYPE)
    }

    getIsUserLoggedIn() {
        return this.get(this.IS_USER_LOGGED_IN) || 'false'
    }

    getDeviceId() {
        return this.get(this.DEVICE_ID)
    }

    getUnicityId() {
        return this.get(this.UNICITY_ID)
    }

    getLanguage() {
        return this.get(this.LANGUAGE) || 'en'
    }

    getCountry() {
        return this.get(this.COUNTRY)
    }

    getInitialReferrer() {
        return this.get(this.INITIAL_REFERRER)
    }

    getInitialReferringDomain() {
        return this.get(this.INITIAL_REFERRING_DOMAIN)
    }

    getUserInitializedInMixpanel() {
        return this.get(this.USER_INITIALIZED_IN_MIXPANEL)
    }

    getIsInitialWithManyRedirects() {
        return this.get(this.IS_INITIAL_WITH_MANY_REDIRECTS)
    }

    removeUserType() {
        this.remove(this.USER_TYPE)
    }

    removeIsUserLoggedIn() {
        this.remove(this.IS_USER_LOGGED_IN)
    }

    removeDeviceId() {
        this.remove(this.DEVICE_ID)
    }

    removeUnicityId() {
        this.remove(this.UNICITY_ID)
    }

    removeLanguage() {
        this.remove(this.LANGUAGE)
    }

    removeCountry() {
        this.remove(this.COUNTRY)
    }

    removeInitialReferrer() {
        this.remove(this.INITIAL_REFERRER)
    }

    removeInitialReferringDomain() {
        this.remove(this.INITIAL_REFERRING_DOMAIN)
    }

    removeUserInitializedInMixpanel() {
        this.remove(this.USER_INITIALIZED_IN_MIXPANEL)
    }

    removeIsInitialWithManyRedirects() {
        this.remove(this.IS_INITIAL_WITH_MANY_REDIRECTS)
    }

    clearAll() {
        this.removeCountry()
        this.removeLanguage()
        this.removeUserType()
        this.removeIsUserLoggedIn()
        this.removeDeviceId()
        this.removeUnicityId()
        this.removeInitialReferrer()
        this.removeInitialReferringDomain()
        this.removeUserInitializedInMixpanel()
    }

    clearInitialReferrerAndReferringDomain() {
        this.removeInitialReferrer()
        this.removeInitialReferringDomain()
        this.removeIsInitialWithManyRedirects()
    }

    clearWhenMixpanelReset() {
        this.removeUserType()
        this.removeIsUserLoggedIn()
        this.removeDeviceId()
        this.removeUnicityId()
        this.removeInitialReferrer()
        this.removeInitialReferringDomain()
        this.removeUserInitializedInMixpanel()
    }

    clearWhenUserLoggedOut() {
        this.removeUserType()
        this.removeIsUserLoggedIn()
        this.removeDeviceId()
        this.removeUnicityId()
        this.removeInitialReferrer()
        this.removeInitialReferringDomain()
        this.removeUserInitializedInMixpanel()
    }

    clearWhenUnAuthorized() {
        this.removeUserType()
        this.removeIsUserLoggedIn()
        this.removeUnicityId()
        this.removeUserInitializedInMixpanel()
    }
}

const mixpanelCookieService = new MixpanelCookieService()

export default mixpanelCookieService